/**
 * Utilidad de Manejo de Permisos
 */

// Permisos por defecto si no hay configuración cargada (Fallback a lógica antigua)
const DEFAULT_ROLES = {
    ADMIN: 1,
    ADMIN_STATION: 5,
    STATION_BOSS: 7,
    CABIN_ATTENDANT: 8,
    FIREFIGHTER: 10
};

/**
 * Verifica si un usuario tiene permiso para una acción específica en una vista.
 * 
 * @param {Object} user - Objeto de usuario (me)
 * @param {string} view - Identificador de la vista (ej: 'emergencies', 'vehicles')
 * @param {string} action - Acción a verificar (ej: 'view', 'create', 'edit', 'delete')
 * @returns {boolean}
 */
export const hasPermission = (user, view, action = 'view') => {
    if (!user) return false;

    // 1. Si el usuario tiene configuración de permisos cargada desde el backend
    if (user.permissions && user.permissions[view]) {
        return !!user.permissions[view][action];
    }

    const userRole = Number((user.role && typeof user.role === 'object') ? user.role.role : user.role);

    // 2. Fallback a lógica hardcoded (Compatibilidad hacia atrás)
    if (userRole === DEFAULT_ROLES.ADMIN) return true;

    // Lógica legacy simplificada
    switch (view) {
        case 'emergencies':
        case 'reports':
            return true; // Casi todos ven emergencias
        case 'vehicles':
            return [DEFAULT_ROLES.ADMIN, DEFAULT_ROLES.ADMIN_STATION].includes(userRole);
        case 'users':
            return [DEFAULT_ROLES.ADMIN, DEFAULT_ROLES.ADMIN_STATION, DEFAULT_ROLES.STATION_BOSS].includes(userRole);
        case 'roles':
            return userRole === DEFAULT_ROLES.ADMIN; // Solo admin puede gestionar roles
        case 'predictive_analysis':
            return [DEFAULT_ROLES.ADMIN, DEFAULT_ROLES.ADMIN_STATION, DEFAULT_ROLES.STATION_BOSS].includes(userRole);
        default:
            return false;
    }
};

/**
 * Obtiene una configuración específica del rol (ej: para cabinistas)
 * 
 * @param {Object} user 
 * @param {string} key 
 * @param {any} defaultValue 
 * @returns {any}
 */
export const getRoleSetting = (user, key, defaultValue = undefined) => {
    if (user && user.settings && user.settings[key] !== undefined) {
        return user.settings[key];
    }
    return defaultValue;
};
